import { z } from '../index.ts'

import { GetUserSchema } from './user.ts'

export const GetHistoryCategorySchema = z.string().min(1)

export const GetHistoryEntrySchema = z.object({
  category: GetHistoryCategorySchema,
  category_label: z.string(),
  created_at: z.coerce.date(),
  description: z.string().nullable(),
  event: z.string(),
  field: z.string().nullable(),
  field_label: z.string().nullable(),
  id: z.number(),
  is_system: z.boolean(),
  new_display: z.string().nullable(),
  new_value: z.string().nullable(),
  old_display: z.string().nullable(),
  old_value: z.string().nullable(),
  subject: z
    .object({
      id: z.number(),
      type: z.string(),
    })
    .nullish(),
  user: GetUserSchema,
})

export const GetHistoryFiltersSchema = z.object({
  categories: z
    .object({
      label: z.string(),
      value: GetHistoryCategorySchema,
    })
    .array(),
  users: GetUserSchema.array(),
})

export type GetHistoryCategory = z.infer<typeof GetHistoryCategorySchema>
export type GetHistoryEntry = z.infer<typeof GetHistoryEntrySchema>
export type GetHistoryFilters = z.infer<typeof GetHistoryFiltersSchema>
